type Immutable<Type> = {
  readonly [Property in keyof Type]: Type[Property];
};

const borderRadius = {
  standard: "10px",
  compact: "5px",
  tiny: "3px",
  scrollbarThumb: "5.5px"
};

// tslint:disable-next-line
export const BorderRadius: Immutable<typeof borderRadius> = borderRadius;
